import {
  REMOVE_LISTS,
  LOAD_COMMAND_CENTER_DASHBOARD_STOCK,
  COMMAND_CENTER_DASHBOARD_LOAD_DIVISION,
  COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT,
  COMMAND_CENTER_DASHBOARD_LOAD_SECTION,
  COMMAND_CENTER_DASHBOARD_LOAD_PLANT,
} from './actions'

const initialState = {
  // *load ข้อมูล dashboard
  stock_list: [],
  check_stock_list: false,

  // *loadข้อมูลสำหรับ filter
  division_list: [],
  check_division_list: false,

  department_list: [],
  check_department_list: false,

  section_list: [],
  check_section_list: false,

  plant_list: [],
  check_plant_list: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_COMMAND_CENTER_DASHBOARD_STOCK.REQUEST:
      return {
        ...state,
        // stock_list: [],
        check_stock_list: true,
      }

    case LOAD_COMMAND_CENTER_DASHBOARD_STOCK.SUCCESS:
      return {
        ...state,
        stock_list: action.payload.lists || [],
        check_stock_list: false,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_DIVISION.REQUEST:
      return {
        ...state,
        division_list: [],
        check_division_list: true,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        division_list: action.payload.lists,
        check_division_list: false,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        department_list: [],
        check_department_list: true,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        department_list: action.payload.lists,
        check_department_list: false,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_SECTION.REQUEST:
      return {
        ...state,
        section_list: [],
        check_section_list: true,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_SECTION.SUCCESS:
      return {
        ...state,
        section_list: action.payload.lists,
        check_section_list: false,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_PLANT.REQUEST:
      return {
        ...state,
        plant_list: [],
        check_plant_list: true,
      }
    case COMMAND_CENTER_DASHBOARD_LOAD_PLANT.SUCCESS:
      return {
        ...state,
        plant_list: action.payload.lists,
        check_plant_list: false,
      }

    default:
      return state
  }
}
